const groupPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.RATINGS)
const groupPrefixOrder = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.ORDER_RATINGS)

export const apiClientRatings = {
	fetchMealRatings: async (clientUuid: string, page: number = 1, perPage: number = 25) => {
		const { data, meta } = await apiCommon<IClientRating[]>(`${groupPrefix}/${clientUuid}`, {
			method: 'GET',
			...createQuery({ page, perPage }),
		})
		return { data: data.map(r => ClientRating(r)), meta }
	},

	fetchOrderRatings: async (clientUuid: string, page: number = 1, perPage: number = 25) => {
		const { data, meta } = await apiCommon<IClientOrderRating[]>(`${groupPrefixOrder}/${clientUuid}`, {
			method: 'GET',
			...createQuery({ page, perPage }),
		})
		return { data: data.map(r => ClientOrderRating(r)), meta }
	},
}
